/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/27/20
Irrigation Reporrt Form
**********************************************************/
import { DatePicker2 } from '../../components/inputs';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const propTypes = {
  employees: PropTypes.array,
  engines: PropTypes.array,
  meters: PropTypes.array,
  valves: PropTypes.array,
  user: PropTypes.object
};

class ReportForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit({startDate, endDate}) {
    if (!(startDate && endDate)) return this.props.error('Please select a start date and end date');
    if (new Date(startDate) > new Date(endDate)) return this.props.error('Start date must precede the end date');
    return this.props.fetchIrrigationReport({
      startDate: moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      email: this.props.user.email
    });
  }
  render() {
    return (
      <div>
        <div className="row">
          <form id={'irrigation-report-form'} onSubmit={(e) => e.preventDefault()}>
            <div className="col s12 m12 l12 xl12">
              <DatePicker2 id={'irrigation-startDate'} label={'Start Date'} />
            </div>
            <div className="col s12 m12 l12 xl12">
              <DatePicker2 id={'irrigation-endDate'} label={'End Date'} />
            </div>
            <center>
              <button className="btn btn-large waves-effect"
                onClick={() => this.handleSubmit({
                  startDate: document.getElementById('irrigation-startDate').value,
                  endDate: document.getElementById('irrigation-endDate').value
                })}
              >
                Run Report
              </button>
            </center>
          </form>
        </div>
      </div>
    );
  }
}


ReportForm.propTypes = propTypes;
export default ReportForm;



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/report_form.js